import { LineWiseGarmentsModel } from "./line-wise-garments.model";

export class HourWiseGarmentsModel {
    hour: number; // for the total hour
    completedGarments: number; // for the total hour across all lines
    plannedGarments: number; // for the total hour across all lines
    rejectedGarments: number; // for the total hour across all lines

    linesWiseGarments: LineWiseGarmentsModel[];

    constructor(hour: number,
        completedGarments: number,
        plannedGarments: number,
        rejectedGarments: number, 
        linesWiseGarments: LineWiseGarmentsModel[]) {
            this.hour= hour;
            this.completedGarments = completedGarments;
            this.plannedGarments = plannedGarments;
            this.rejectedGarments = rejectedGarments;
            this.linesWiseGarments = this.linesWiseGarments;
            this.linesWiseGarments = linesWiseGarments;
    }
}